export class Dishes {
  constructor() {
    this.name = "";
    this.code="";
    (this.avrage_gooking_time = null),
      (this.is_ready_made = false),
      (this.categories = []),
      (this.types = []),
      (this.ingredients = []);
  }

  toRequest(u) {
    
    var data = {};

    (data.id = u.id),
      (data.name = u.name),
      (data.code =u.code),
      (data.avrage_gooking_time = u.avrage_gooking_time),
      (data.is_ready_made = u.is_ready_made),
      (data.ingredients = u.Ingredients),
      (data.types = u.Types),
      (data.categories = [u.Categories]);

    return data;
  }
  toViewModal(u) {
    
    let data = new Object();

    (data.id = u.id), (data.name = u.name), (data.id = u.id ? u.id : "");
    data.name = u.name ? u.name : "";
    data.code = u.code?u.code:"";
    data.avrage_gooking_time = u.avrage_gooking_time
      ? u.avrage_gooking_time
      : "";
    data.is_ready_made = u.is_ready_made ? "Yes" : "No";

    data.ingredients = u.ingredients ? u.ingredients : "";
    data.types = u.types ? u.types : "";
    data.categories = u.categories ? u.categories : "";

    return data;
  }

  
  toView(u) {
    
    const data = new Dishes();

    data.id = u.id ? u.id : "";
    data.image = u.image ? u.image : "";
    data.name = u.name ? u.name : "";
    data.code = u.code?u.code : "";
    data.avrage_gooking_time = u.avrage_gooking_time
      ? u.avrage_gooking_time
      : "";
    data.is_ready_made = u.is_ready_made ? "Yes": "No";

    data.types = u.types;
    data.ingredients = u.ingredients;

    data.categories = u.categories.map((item) => {
      return {
        id: item.id,
        name:item.name
      };
    });

    // data.categories = u.categories ? u.categories.id:'';

    return data;
  }

  Initialise(u) {
    
    const data = new Dishes();

    data.id = u.id ? u.id : "";
    data.image = u.image ? u.image : "";
    data.name = u.name ? u.name : "";
    data.code = u.code ? u.code:"";
    data.avrage_gooking_time = u.avrage_gooking_time
      ? u.avrage_gooking_time
      : "";
    data.is_ready_made = u.is_ready_made;

    data.types = u.types;
    data.ingredients = u.ingredients;

    data.categories = u.categories.map((item) => {
      return {
        id: item.id,
      };
    });

    // data.categories = u.categories ? u.categories.id:'';

    return data;
  }
}
